module.exports = {"321071050":"扬子津街道","321071051":"文汇街道","321071150":"施桥镇","321071151":"八里镇","321071152":"朴席镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321071.json
// module id = 918
// module chunks = 0